export const formatCurrency = (value: number) => {
	if (value === 0) return 'R$ --';

	return Intl.NumberFormat('pt-BR', {
		style: 'currency',
		currency: 'BRL',
	}).format(value);
};

export const formatDollar = (value: number) => {
	if (value === 0) return 'US$ --';

	return Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		currencyDisplay: 'narrowSymbol'
	}).format(value).replace('$', 'US$');
};
